var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useSiteRouteComponents } from '../../hooks/site-route/useSiteRouteComponents';
const SiteRoutePicker = props => {
    const { value, onChange, variant } = props, textFieldProps = __rest(props, ["value", "onChange", "variant"]);
    const routes = useSiteRouteComponents();
    const [selected, setSelected] = useState(() => {
        return value ? routes.find(route => route.id === value) : undefined;
    });
    useEffect(() => {
        setSelected(routes.find(route => route.id === value));
    }, [value, routes]);
    // console.log('SiteRoutePicker value', value);
    const additionalInputProps = {};
    if (!variant)
        additionalInputProps.disableUnderline = true;
    // console.log('selected', selected);
    return (React.createElement(Autocomplete, { fullWidth: true, options: routes, value: selected || null, disabled: textFieldProps.disabled, disableClearable: textFieldProps.disabled, onChange: (_, value) => {
            onChange === null || onChange === void 0 ? void 0 : onChange(value || undefined);
            console.log('value', value);
            setSelected(routes.find(route => route.id === (value === null || value === void 0 ? void 0 : value.id)));
        }, getOptionLabel: option => {
            var _a;
            let path = ((_a = option.props) === null || _a === void 0 ? void 0 : _a.path) || '';
            path = path && ` -> ${path}`;
            return option.name + path;
        }, renderInput: params => (React.createElement(TextField, Object.assign({ variant: variant }, params, { fullWidth: true, size: 'small', placeholder: 'Select Route' }, textFieldProps, { InputProps: Object.assign(Object.assign({}, params.InputProps), additionalInputProps) }))) }));
};
export default SiteRoutePicker;
//# sourceMappingURL=SiteRoutePicker.js.map